<div class="header-wrapper">
  <div class="header-container">
    <div class="mobile-branding">
      <button class="mobile-menu-btn" type="button" (click)="toggleMobileMenu()" aria-label="Abrir menú">
        <img src="/header/png/Burger_menu.svg" alt="" class="icon icon-menu" />
      </button>
      <img src="/header/png/Ribera_logo_color.svg" alt="Ribera del Río" class="mobile-logo" />
    </div>
    <div class="logo-section">
      <div class="card flex justify-center">
          <p-breadcrumb [home]="home" [model]="items" />
      </div>
    </div>
    <div class="spacer"></div>
    <div class="right-section">
        <div class="user-info">
            <lib-ribera-avatar-ui
                [image]="authStore.userLoginData()?.avatar ?? ''"
                [size]="'medium'"
                [shape]="'circle'"
                [name]="authStore.userLoginData()?.name ?? ' ? '"
            >
            </lib-ribera-avatar-ui>
            <div class="name-info">
                <h4 class="desktop-user-name">{{ authStore.userLoginData()?.name }}</h4>
                <h4 class="mobile-section-title">{{ currentSectionTitle }}</h4>
                <span class="type-document">
                    @if (authStore.userLoginData()?.documentType) {
                        {{ authStore.userLoginData()?.documentType }}
                        : 
                        {{ authStore.userLoginData()?.documentNumber }}
                    }
                </span>
                @if (currentUserLabel) {
                  <span class="mobile-user-label">{{ currentUserLabel }}</span>
                }
            </div>
            <button class="toggle-options" (click)="toggleMenu()">
                <img [src]="menuIcon" alt="Options" class="icon icon-menu"/>
            </button>
        </div>
        <button
            class="btn-alerts"
            (click)="viewNotifications()"
        >
            <img src="/header/icons/alert-icon.svg" alt="Menu" class="icon icon-menu" />
        </button>
    </div>
  </div>

</div>

